import { render, staticRenderFns } from "./DialogOrBottomSheet.vue?vue&type=template&id=46c57e37&scoped=true"
import script from "./DialogOrBottomSheet.vue?vue&type=script&lang=js"
export * from "./DialogOrBottomSheet.vue?vue&type=script&lang=js"
import style0 from "./DialogOrBottomSheet.vue?vue&type=style&index=0&id=46c57e37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c57e37",
  null
  
)

export default component.exports